import vivaLogo from 'assets/icons/viva-logo-white.svg';

function VivaLogo() {
  return <img src={vivaLogo} alt="Viva Logo" width={110} />;
}

export default VivaLogo;
